import React, { useState, FC, useEffect } from "react";
import TabButton from "../../components/layout/Sections/TabButton";
import TabContent from "../../components/layout/Sections/TabContent";
import Contaier from "../../components/layout/Container/Container";
import Banner from "../../components/layout/Sections/Banner";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";

import { useLocation, useParams, useNavigate } from "react-router-dom";
import HarvestDetailsRegistration from "./HarvestDetailsRegistration";
import HarvestDetailsRFA from "./HarvestDetailsRFA";
import HarvestDetailsDashboard from "../DashBoard/Harvest/HarvestDetailsDashboard";

export interface HarvestDetailsProps {
  HarvestDetailsId: any;
}

const HarvestDetails = () => {
  const name = "E-services";
  const name2 = "Application Details";
  const buttonName = "Registration";
  const buttonName2 = "RFA";
  const buttonName3 = "Dashboard";

  let navigate = useNavigate();
  const location = useLocation();
  const bannerType = location.state;
  let bannerName = "Harvest Details Registration";
  const harvestDetailsId = location.state?.id;
  const tab = location.state?.activeTab;

  const { param } = useParams();
  const [activeButton, setActiveButton] = useState<string>("v-pills-home-tab");
  const [activeTab, setActiveTab] = useState<string>("v-pills-home");
  // const [bannerType, setBannerType] = useState<string>(
  //   "HarvestDetailsApplication"
  // );
  const handleButtonClick = (buttonId: string, tabId: string) => {
    setActiveButton(buttonId);
    setActiveTab(tabId);
  };

  const handleButtonClick2 = (buttonId: string, tabId: string) => {
    let path = `/app-harvest-dashboard`;
    navigate(path);
  };

  useEffect(() => {
    if (harvestDetailsId !== undefined) {
      setActiveButton("v-pills-home-tab");
      setActiveTab("v-pills-home");
    }
    if (tab === "dashboard") {
      setActiveButton("v-pills-services-tab");
      setActiveTab("v-pills-services");
      // setBannerType("HarvestDetailsDashboard");
    }
  }, [harvestDetailsId, tab]);

  interface TabPages {
    [key: string]: FC<any>; // Use the appropriate prop type for your components
  }

  const tabPages: TabPages = {
    "v-pills-home": HarvestDetailsRegistration,
    "v-pills-services": HarvestDetailsDashboard,
    // "v-pills-rfa": HarvestDetailsRFA,
    // ... add other tab pages here
  };

  return (
    <>
      <Header />
      <Contaier>
        <Banner name={bannerName} uiClass="banner-bg" />
        <div className="inner-content">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-2">
                <div className="filter-cnt">
                  <h3>{name}</h3>
                  <span>{name2}</span>
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <TabButton
                      buttonId="v-pills-home-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick("v-pills-home-tab", "v-pills-home")
                      }
                    >
                      {buttonName}
                    </TabButton>
                    {/* <TabButton
                      buttonId="v-pills-profile-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick("v-pills-rfa-tab", "v-pills-rfa")
                      }
                    >
                      {buttonName2}
                    </TabButton> */}
                    <TabButton
                      buttonId="v-pills-services-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-services-tab",
                          "v-pills-services"
                        )
                      }
                    >
                      {buttonName3}
                    </TabButton>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-10">
                <div className="tab-content" id="v-pills-tabContent">
                  {Object.keys(tabPages).map((tabId) => (
                    <TabContent key={tabId} tabId={tabId} activeTab={activeTab}>
                      {tabPages[tabId]({ RegistrationType: bannerType })}
                    </TabContent>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Contaier>
      <Footer />
    </>
  );
};

export default HarvestDetails;
